import { render, staticRenderFns } from "./GerarRelatoriosImoveis.vue?vue&type=template&id=540a85a2&scoped=true&"
import script from "./GerarRelatoriosImoveis.vue?vue&type=script&lang=js&"
export * from "./GerarRelatoriosImoveis.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatoriosImoveis.vue?vue&type=style&index=0&id=540a85a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a85a2",
  null
  
)

export default component.exports